import { render, staticRenderFns } from "./PracticeSuccessRequestSent.vue?vue&type=template&id=46e384fe&"
import script from "./PracticeSuccessRequestSent.vue?vue&type=script&lang=js&"
export * from "./PracticeSuccessRequestSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports